<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="កញ្ចប់ឥវ៉ាន់ទាំងអស់" name="first"></el-tab-pane>
			<!-- <el-tab-pane label="New loan" name="second"></el-tab-pane> -->
			<!-- <el-tab-pane label="Loan calculator" name="third"></el-tab-pane> -->
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>ស្វែងរកតាមរយៈ លេខកូដ លេខទូរស័ព្ទ អ្នកផ្ញើរ ឬ អ្នកទទួល</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-70 md-size-20">
					<md-field>
						<label>ស្ថានភាព</label>
						<md-select placeholder="ស្ថានភាព (ទាំងអស់)" v-model="search.status">
							<md-option value="">ទាំងអស់</md-option>
							<md-option value="ndv">មិនមានអ្នកដឹក</md-option>
							<md-option value="wdv">កំពុងរង់ចាំអ្នកដឹក</md-option>
							<md-option value="dvr">កំពុងដឹកជញ្ជូន</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-30 md-size-20">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">ស្វែងរក
					</md-button>
				</div>
			</div>
			<md-table v-if="packageList.length > 0">
				<md-table-row>
					<!-- <md-table-head>ល.រ</md-table-head> -->
					<md-table-head>លេខកូដ</md-table-head>
					<md-table-head>ប្រភេទ និងទីតាំង</md-table-head>
					<md-table-head>អ្នកផ្ញើរ</md-table-head>
					<md-table-head>អ្នកទទួល និងចំណាំ</md-table-head>
					<md-table-head>អ្នកដឹកជញ្ជូន</md-table-head>
					<md-table-head>តម្លៃឥវ៉ាន់</md-table-head>
					<md-table-head>ថ្លៃដឹកជញ្ជូន</md-table-head>
					<md-table-head>អ្នកបញ្ចូល</md-table-head>
					<md-table-head>ស្ថានភាព</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>

				<md-table-row v-for="(pkg, index) in packageList">
					<!-- <md-table-cell></md-table-cell> -->
					<md-table-cell>​{{ index + 1 }}, <b>{{ pkg.tracking }}</b><br>{{config.datelify(pkg.created_date)}}
					</md-table-cell>
					<md-table-cell><b>{{ pkg.location }}</b><br>{{ pkg.package_type }}</md-table-cell>
					<md-table-cell>{{pkg.sender_phone}} <br>({{pkg.client_name}})</md-table-cell>
					<md-table-cell>{{ pkg.receiver_phone }}<br>{{pkg.note}}</md-table-cell>
					<md-table-cell>
						<span v-if="pkg.status == 'ndv'">មិនមានអ្នកដឹក</span>
						<span v-else>{{ pkg.driver_phone }}<br>({{ pkg.driver_name }})</span>
					</md-table-cell>
					<md-table-cell><b>{{ config.moneylify(pkg.price, pkg.price_currency) }}</b><br><span
							v-if="pkg.price == 0">(ទូទាត់រួច)</span><span v-else>(មិនទាន់ទូទាត់)</span></md-table-cell>
					<md-table-cell><b>{{ config.moneylify(pkg.fee, pkg.fee_currency) }}</b><br>
						({{config.getStatus(pkg.fee_responsible)}})</md-table-cell>
					<md-table-cell>{{pkg.issue_by}}</md-table-cell>
					<md-table-cell>
						<span class="error" v-if="pkg.status == 'ndv'">{{ config.getStatus(pkg.status) }}</span>
						<span class="late" v-if="pkg.status == 'wdv'">{{ config.getStatus(pkg.status) }}</span>
						<span class="neutral" v-if="pkg.status == 'dvr'">{{ config.getStatus(pkg.status) }}</span>
						<span class="green" v-if="pkg.status == 'dlv'">{{ config.getStatus(pkg.status) }}</span>
						<span class="return" v-if="pkg.status == 'rtn'">{{ config.getStatus(pkg.status) }}</span>
					</md-table-cell>
					<md-table-cell>
						<router-link :to="'/packages/detail/' + pkg.hash_id">
							<md-button class="md-just-icon md-simple md-primary">
								<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">មើលលំអិត</md-tooltip>
							</md-button>
						</router-link>
						<template v-if="$store.state.authentication.account_type == 'sa' || $store.state.authentication.account_type == 'ad'">
							<md-button class="md-just-icon md-simple md-danger" @click="showDeleteAction(pkg.id)">
								<md-icon>fact_check</md-icon>
								<md-tooltip md-direction="top">លុបចេញពីតារាងមានបញ្ហា</md-tooltip>
							</md-button>
						</template>
					</md-table-cell>

				</md-table-row>
			</md-table>
			<h4 class="text-center" v-if="packageList.length == 0 && loadMore == true">មិនមានកញ្ចប់ឥវ៉ាន់</h4>
			<div class="places-buttons text-center" v-if="loadMore">
				<md-button class="md-primary" @click="searchHandler(true)">បង្ហាញបន្ថែម</md-button>
			</div>
		</div>


		<md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="តើអ្នកពិតជាចង់លុបកញ្ចប់ចេញពីតារាងមានបញ្ហាពិតមែនទេ ?"
			md-content="" md-confirm-text="លុបចេញពីតារាង"
			md-cancel-text="បោះបង់" @md-cancel="onCancel" @md-confirm="onDelete" />
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				deleteDialogActive: false,
				deleteSelected: '',
				search: {
					text: "",
					status: ""
				},
				loadMore: false,
				packageList: []
			}
		},
		methods: {
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/package/search_issue", {
					text: this.search.text,
					status: this.search.status,
					offset: more ? this.packageList.length : 0
				}).then(data => {
					this.loaded = true;
					this.search.text = "";
					if (data.body.data.length == 100) this.loadMore = true;
					else this.loadMore = false;
					this.packageList = more ? this.packageList.concat(data.body.data) : data.body.data;
				})

			},
			showDeleteAction(id) {
				this.deleteSelected = id
				this.deleteDialogActive = true
			},
			onDelete() {
				this.$http.post(this.config.api + "/admin/package/issue_remove", {
					id: this.deleteSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "កញ្ចប់ឥវ៉ាន់ត្រូវបានលុបចេញពីតារាងមានបញ្ហាដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						// this.getEndLicense();
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onCancel() {
				this.deleteSelected = ""
				this.deleteDialogActive = false
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/ErrorPackages/View.vue